import { useState } from 'react'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'

import { Input } from '@/components/ui/input'

interface PasswordInputProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  id?: string
  name?: string
  label?: string
  placeholder?: string
  testId?: string
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  id = 'password',
  name = 'password',
  placeholder = 'Enter your password',
  testId,
}) => {
  const [show, setShow] = useState(false)

  return (
    <div className="w-full">
      <div className="relative">
        <Input
          id={id}
          name={name}
          type={show ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          data-testid={testId}
          className="placeholder:text-slate-400 w-full rounded-lg border border-gray-300 px-4 py-2 pr-10 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        />
        <button
          type="button"
          onClick={() => setShow((prev) => !prev)}
          className="absolute inset-y-0 right-2 flex items-center px-1 text-gray-500 hover:text-gray-700 focus:outline-none"
          aria-label={show ? 'Hide password' : 'Show password'}
        >
          {show ? (
            <EyeSlashIcon className="h-5 w-5" />
          ) : (
            <EyeIcon className="h-5 w-5" />
          )}
        </button>
      </div>
    </div>
  )
}
